export const styles = {
  toolsMenu: {
    mx: "0.5em",
  },
  menuButton: {
    p: 0,
  },
  menuIcon: (theme) => ({
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentcolor",
    flexShrink: 0,
    transition: "fill 200ms cubic- bezier(0.4, 0, 0.2, 1) 0ms",
    fontSize: "1.51429rem",
    color: theme.palette.common.white,
    // marginLeft: "0.5em",
    // marginRight: "0.1em",
  }),
  menuPaper: {
    elevation: 0,
    sx: {
      overflow: "visible",
      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
      mt: 1.5,
      "& .MuiAvatar-root": {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1,
      },
      "&:before": {
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        right: 14,
        width: 10,
        height: 10,
        bgcolor: "background.paper",
        transform: "translateY(-50%) rotate(45deg)",
        zIndex: 0,
      },
    },
    className: "menu-tools-paper",
  },
  avatar: (theme) => ({
    bgcolor: theme.palette.primary.main,
    mr: "0px!important",
  }),
  iconMenu: (theme) => ({
    width: 32,
    height: 32,
    color: theme.palette.primary.main,
  }),
  revertIcon: (theme) => ({
    width: 32,
    height: 32,
    color: theme.palette.primary.main,
    transform: "rotateX(180deg)",
  }),
  highlightButton: (theme) => ({
    // backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    animation: "pulse 1.5s ease-in-out infinite",
    "@keyframes pulse": {
      "0%": {
        boxShadow: `0 0 0 0 ${theme.palette.primary.main}80`,
      },
      "50%": {
        boxShadow: `0 0 0 10px ${theme.palette.primary.main}00`,
      },
      "100%": {
        boxShadow: `0 0 0 0 ${theme.palette.primary.main}00`,
      },
    },
  }),
  toolsText: (theme) => ({
    color: theme.palette.common.white,
    fontSize: 10,
  })
}
